import React from 'react';
import { Mutation, MutationComponentOptions } from '@apollo/client/react/components';

interface Props<T, U> extends MutationComponentOptions<T, U> {
    onProgress?: XMLHttpRequestUpload['onprogress'];
}

function MutationWithProgress<T, U>(props: Props<T, U>) {
    const { onProgress, ...rest } = props;

    const headers = rest.context && rest.context.headers;

    return <Mutation {...props} context={{ ...props.context, headers: { ...headers, onProgress } }} />;
}

export default MutationWithProgress;
